import { i18n } from '~/utils';

/**
 * Incoterms, short for "International Commercial Terms", are standardized trade terms
 * issued by the International Chamber of Commerce (ICC)
 * that regulate the rights and obligations of buyers and sellers in international trade in goods
 */
export const INCOTERMS = [
  'CFR',
  'CIF',
  'CIP',
  'CPT',
  'DAP',
  'DDP',
  'DPU',
  'EXW',
  'FAS',
  'FCA',
  'FH',
  'FOB',
] as const;

export const INCOTERMS_I18N_MAP = () => ({
  CFR: i18n.t(($) => $.incoterm.CFR, { ns: 'deliveryNotes' }),
  CIF: i18n.t(($) => $.incoterm.CIF, { ns: 'deliveryNotes' }),
  CIP: i18n.t(($) => $.incoterm.CIP, { ns: 'deliveryNotes' }),
  CPT: i18n.t(($) => $.incoterm.CPT, { ns: 'deliveryNotes' }),
  DAP: i18n.t(($) => $.incoterm.DAP, { ns: 'deliveryNotes' }),
  DDP: i18n.t(($) => $.incoterm.DDP, { ns: 'deliveryNotes' }),
  DPU: i18n.t(($) => $.incoterm.DPU, { ns: 'deliveryNotes' }),
  EXW: i18n.t(($) => $.incoterm.EXW, { ns: 'deliveryNotes' }),
  FAS: i18n.t(($) => $.incoterm.FAS, { ns: 'deliveryNotes' }),
  FCA: i18n.t(($) => $.incoterm.FCA, { ns: 'deliveryNotes' }),
  FH: i18n.t(($) => $.incoterm.FH, { ns: 'deliveryNotes' }),
  FOB: i18n.t(($) => $.incoterm.FOB, { ns: 'deliveryNotes' }),
});
